module.exports = __webpack_public_path__ + "static/img/wind_card@2x.f23a4866.png";